
export function dateTimeTzToLocale(date) {
    const dt = new Date(date);
    return `${dt.toLocaleDateString()} à ${dt.toLocaleTimeString()}`
}
